export const howItWorksItems = [
    {
        description: 'Acquire an NFT from our founder edition and become an official member of our community.'
    },
    {
        description: 'Each NFT held by a user provides access to airdrop shares. Airdrops are issued in digital items.'
    },
    {
        description: 'NFT sale profits are used to finance and produce Entertainment projects.'
    },
    {
        description: 'Upon release of new feature productions, we will reward NFT holders with digital item airdrops.'
    },
    {
        description: 'NFT holders are eligible to access our airdrop reward system at the time of airdrop.'
    },
    {
        description: 'Join our discord server and participate in the next revolution of movie creation.'
    }
]